export default function InfoandSupport () {
    return (
        <div>
        <h2>Information and support</h2>
        <div className="mb-2 divider" />
        <p>
          For any issue concerning the REST API of DISGENET, please contact{' '}
          <a href="mailto:info@disgenet.com" title="copy">
            info@disgenet.com
          </a>
          .
        </p>
      </div>
    )
}